export class NewsFeedRequestSerializer {
  constructor({ isin, offset, filterDate }) {
    this.offset = offset;
    this.locale = "en";
    this.limit = 200;
    this.category_theme = [];
    this.for_id = isin;

    const startDate =
      filterDate.startDate === "" ? new Date() : new Date(filterDate.startDate);
    this.start_date = new Date(
      Date.UTC(
        startDate.getFullYear(),
        startDate.getMonth(),
        startDate.getDate()
      )
    );

    const endDate =
      filterDate.endDate === "" ? new Date() : new Date(filterDate.endDate);
    this.end_date = new Date(
      Date.UTC(endDate.getFullYear(), endDate.getMonth(), endDate.getDate())
    );
  }

  getRequest = () => {
    return JSON.stringify(this);
  };
}


export class NewsRequestSerializer {
  constructor({ document_id}) {
    this.document_id = document_id;
  }

  getRequest = () => {
    return JSON.stringify(this);
  };
}